
export const ACTION = {
  CREATE: 'insert',
  READ: 'select',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const ACTIONS = [
  {
    label: 'Crear',
    name: ACTION.CREATE,
  },
  {
    label: 'Leer',
    name: ACTION.READ,
  },
  {
    label: 'Actualizar',
    name: ACTION.UPDATE,
  },
  {
    label: 'Eliminar',
    name: ACTION.DELETE,
  },
];

export const MODULE = {
  DASHBOARD: 'front_dashboard',
  PEOPLE: 'front_people',
  PRODUCTS: 'front_products',
  TEMPLATES_PEOPLE: 'front_templates_people',
  TEMPLATES_PRODUCTS: 'front_templates_products',
  TEMPLATES_NOTIFICATIONS: 'front_templates_notifications',
  CAMPAIGNS: 'front_campaigns',
  GROUPS: 'front_groups',
  FLOWS: 'front_flows',
  USERS: 'front_users',
  ROLES: 'front_roles',
  LOGS_BINNACLE: 'front_logs_binnacle',
  PLD_ANALYSIS: 'front_pld_analists',
  PLD_MANAGEMENT: 'front_pld_management',
  PLD_REPORTS: 'front_pld_reports',
  PLD_WARNING: 'front_pld_warning',
};

export const MODULES = [
  {
    label: 'Dashboard',
    name: MODULE.DASHBOARD,
  },
  {
    label: 'Clientes',
    name: MODULE.PEOPLE,
  },
  {
    label: 'Productos',
    name: MODULE.PRODUCTS,
  },
  {
    label: 'Plantillas: Clientes',
    name: MODULE.TEMPLATES_PEOPLE,
  },
  {
    label: 'Plantillas: Productos',
    name: MODULE.TEMPLATES_PRODUCTS,
  },
  {
    label: 'Plantillas: Notificaciones',
    name: MODULE.TEMPLATES_NOTIFICATIONS,
  },
  {
    label: 'Campañas',
    name: MODULE.CAMPAIGNS,
  },
  {
    label: 'Grupos',
    name: MODULE.GROUPS,
  },
  {
    label: 'Flujos',
    name: MODULE.FLOWS,
  },
  {
    label: 'Usuarios',
    name: MODULE.USERS,
  },
  {
    label: 'Roles',
    name: MODULE.ROLES,
  },
  {
    label: 'PLD: Administración',
    name: MODULE.PLD_MANAGEMENT,
  },
  {
    label: 'PLD: Modelos de alertamiento',
    name: MODULE.PLD_WARNING,
  },
  {
    label: 'PLD: Proceso de análisis',
    name: MODULE.PLD_ANALYSIS,
  },
  {
    label: 'PLD: Reportes internos',
    name: MODULE.PLD_REPORTS,
  },
  {
    label: 'LOGS: Bitácora',
    name: MODULE.LOGS_BINNACLE,
  },
];
